"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _react = _interopRequireWildcard(require("react"));
var _table = _interopRequireDefault(require("../../../../core/table"));
var _occasion = _interopRequireDefault(require("occasion"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _inputOnBlur = _interopRequireDefault(require("../../../../core/input-on-blur"));
var _editableField = _interopRequireDefault(require("../../../../core/editable-field"));
var _deleteButton = _interopRequireDefault(require("../../../../core/delete-button"));
var _tooltip = _interopRequireDefault(require("../../../../core/tooltip"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _mergeBqlQueries(firstQuery, secondQuery) { if (secondQuery === null) { return firstQuery; } const result = {}; let firstQueryUpdated = false; let secondQueryUpdated = false; for (let key in firstQuery) { if (key in firstQuery) { if (!secondQuery[key]) { firstQueryUpdated = true; result[key] = firstQuery[key]; } else if (firstQuery[key] !== secondQuery[key]) { result[key] = _mergeBqlQueries(firstQuery[key], secondQuery[key]); if (result[key] !== secondQuery[key]) { firstQueryUpdated = true; secondQueryUpdated = true; } } else { result[key] = firstQuery[key]; } } } if (!firstQueryUpdated) { return secondQuery; } for (let key in secondQuery) { if (key in secondQuery && !result[key]) { secondQueryUpdated = true; result[key] = secondQuery[key]; } } return secondQueryUpdated ? result : firstQuery; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var _ref = /*#__PURE__*/_react.default.createElement("h4", {
  className: "card-header"
}, " Entry Limits by Day");
var _ref2 = /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", null, /*#__PURE__*/_react.default.createElement("th", null), /*#__PURE__*/_react.default.createElement("th", null, "Date"), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
  placement: "top",
  overlay: "This is the number of completed/accepted entries for the day. It may include entries that are not included in the entry limits!"
}, /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Entries")), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
  placement: "top",
  overlay: "This is the number of entries on the waiting list for the day. It may include entries for races that have their own individual entry limits"
}, /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Waiting List")), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
  placement: "top",
  overlay: "The overall, publicised, entry limit for the day."
}, /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Entry Limit")), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
  placement: "top",
  overlay: "This allows the organiser to reserve places without having  entered them on the system."
}, /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-right"
}, "Reserved Entry")), /*#__PURE__*/_react.default.createElement(_tooltip.default, {
  placement: "top",
  overlay: "This is set automatically when 'entries' >= 'entry limit' - 'reserved entry'. Once set it remains set.  It can be manually unset here, but only if the waiting list for the competition is empty."
}, /*#__PURE__*/_react.default.createElement("th", {
  className: "text-xs-center"
}, "Full"))));
class CompetitionDays extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "_onChange", (id, field, value) => {
      this.props.onUpdateCompetitionDay(id, field, value);
    });
    _defineProperty(this, "_onCheckboxChange", (id, field, e) => {
      this.props.onUpdateCompetitionDay(id, field, e.target.checked);
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "card"
    }, _ref, /*#__PURE__*/_react.default.createElement("div", {
      className: "card-block"
    }, /*#__PURE__*/_react.default.createElement(_table.default, null, _ref2, /*#__PURE__*/_react.default.createElement("tbody", null, this.props.competitionDays.map(day => /*#__PURE__*/_react.default.createElement("tr", {
      key: day.id
    }, /*#__PURE__*/_react.default.createElement("td", null, !day.userCanDeleteDay ? null : /*#__PURE__*/_react.default.createElement(_deleteButton.default, {
      size: "sm",
      onClick: this.props.onDelete.bind(this.props, day.id)
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "read-only"
    }, (0, _occasion.default)(day.dayDate, 'ddd, D MMM YYYY')), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right read-only"
    }, day.numberOfCompletedEntries), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right read-only"
    }, day.numberOnWaitingList), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      className: "text-xs-right",
      type: "Integer",
      name: "entryLimit",
      value: day.entryLimit,
      onChange: this._onChange.bind(this, day.id, 'entryLimit'),
      maxlength: 4,
      required: true
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-right"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: true,
      className: "text-xs-right",
      type: "Integer",
      name: "reservedEntry",
      value: day.reservedEntry,
      onChange: this._onChange.bind(this, day.id, 'reservedEntry'),
      maxlength: 4,
      required: true
    })), /*#__PURE__*/_react.default.createElement("td", {
      className: "text-xs-center"
    }, /*#__PURE__*/_react.default.createElement(_editableField.default, {
      enabled: !day.isFull || !day.numberOnWaitingList > 0,
      type: "Checkbox",
      name: "isFull",
      checked: day.isFull,
      onChange: this._onChange.bind(this, day.id, 'isFull')
    })))))), !this.props.userCanModifyCompetitionStructure ? null : /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this.props.onAddDay,
      block: true,
      size: "sm"
    }, "Add Day")));
  }
  // ****************************************************************************
  // PartialQuery definition
  // ****************************************************************************
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
_defineProperty(CompetitionDays, "partials", {
  CompetitionDays: {
    id: true,
    userCanDeleteDay: true,
    dayDate: true,
    numberOfCompletedEntries: true,
    numberOnWaitingList: true,
    entryLimit: true,
    reservedEntry: true,
    isFull: true
  }
});
var _default = exports.default = (0, _reactBicycle.connect)(CompetitionDays, undefined, (client, props) => ({
  onUpdateCompetitionDay(id, field, value) {
    return client.update('CompetitionDay.set', {
      id,
      field,
      value
    });
  },
  onDelete(id) {
    return client.update('CompetitionDay.delete', {
      id
    });
  },
  onAddDay() {
    return client.update('CompetitionDay.create', {
      competitionID: props.competitionID
    });
  }
}));